import { render, staticRenderFns } from "./YandexFeed.vue?vue&type=template&id=48f4117a&"
import script from "./YandexFeed.vue?vue&type=script&lang=js&"
export * from "./YandexFeed.vue?vue&type=script&lang=js&"
import style0 from "./YandexFeed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports